import { lazy, Suspense, useMemo } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import { ROUTE_DEFINITIONS } from './routeConfig';

const lazyRoutes = ROUTE_DEFINITIONS.map((route) => ({
  path: route.path,
  Component: lazy(route.load),
}));

const AppRoutes = () => {
  const routes = useMemo(() => lazyRoutes, []);

  return (
    <Suspense
      fallback={
        <div style={{ padding: 80, textAlign: 'center', letterSpacing: 2, textTransform: 'uppercase' }}>
          Loading…
        </div>
      }
    >
      <Routes>
        <Route element={<MainLayout />}>
          {routes.map(({ path, Component }) =>
            path === '/' ? (
              <Route index key={path} element={<Component />} />
            ) : (
              <Route key={path} path={path} element={<Component />} />
            ),
          )}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
